import Modal from '../common/modal'
import Button from '@mui/material/Button'
import { Stack, Box, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import { Item, successPopUpKeyDown } from '../common/snippets'
import { useAtom } from 'jotai'
import { stickerFromAtom, stickerToAtom } from '../common/jotaiState/lrSearchAtoms'
import LineinputV2 from '../common/lineinputV2'
import { modalAtom } from '../common/jotaiState/globalStateAtoms'
import { getInt } from '../common/helper'
import { useTranslation } from '../../i18n/I18nProvider'

export const StickerConfirmation = (props) => {
  const { translations } = useTranslation()
  const cs = translations?.common || {}
  const bs = translations?.booking || {}
  const { yesDefault, stickerRange } = props
  const from = 1
  const to = stickerRange ||1
  const { yesAction, noAction } = props
  const buttonRef1 = useRef(null)
  const buttonRef2 = useRef(null)
  const [stickerFrom, setStickerFrom] = useAtom(stickerFromAtom)
  const [stickerTo, setStickerTo] = useAtom(stickerToAtom)
  const [, setModal] = useAtom(modalAtom)
  const [key, setKey] = useState(0)
  const [key2, setKey2] = useState(0)
  const handleBlur = (e, type) => {
    const value = +e.target.value
    if (type === 1) {
      setKey(key + 1)
      if (value >= from && value <= to) {
        setStickerFrom(value)
      } else {
        setStickerFrom(from)
      }
    }
    if (type === 2) {
       setKey2(key2 + 1)
      if (value >= from && value <= to && value >= stickerFrom) {
        setStickerTo(value)
      } else {
        setStickerTo(to)
      }
    }
  }
  useEffect(() => {
    if (yesDefault) {
      buttonRef1.current.focus()
    } else {
      buttonRef2.current.focus()
    }
  }, [])
  return (
    <Modal headTxt={bs.printSticker} width={'35%'} updateModal={noAction}>
      <Stack>
        <Box style={{ margin: '20px', fontSize: '19px' }}>
          <Typography sx={{ fontSize: '16px', textAlign: 'center', fontWeight: 'bold' }}>{bs.doYouWantToPrintStickers}</Typography>
          <Item sx={{ width: '100%', padding: '0px', display: 'flex', alignItems: 'center', marginTop: '15px' }}>
            <Typography sx={{ color: '#444', fontSize: '15px', fontWeight: 500, whiteSpace: 'nowrap' }}>{bs.stickersFrom}</Typography>
            <Item sx={{ width: '100%', padding: '0px 10px' }}>
              <div className={'input--wrapper'} style={{ width: '100%', margin: 0 }}>
                <LineinputV2 key={key} disabled={to === 1} value={stickerFrom} filter={getInt} onBlur={(e) => handleBlur(e, 1)} />
              </div>
            </Item>
            <Typography sx={{ color: '#444', fontSize: '15px', fontWeight: 500, whiteSpace: 'nowrap' }}>{bs.stickersTo}</Typography>
            <Item sx={{ width: '100%', padding: '0px 10px' }}>
              <div className={'input--wrapper'} style={{ width: '100%', margin: 0 }}>
                <LineinputV2 key={key2} disabled={to === 1} value={stickerTo} filter={getInt} onBlur={(e) => handleBlur(e, 2)} />
              </div>
            </Item>
          </Item>
          {to === 1 ? (
            <></>
          ) : (
            <Typography sx={{ fontSize: '13px', marginTop: '10px', textAlign: 'center' }}>
              {bs.pleaseEnterStickerRange?.replace('{from}', from).replace('{to}', to)}
            </Typography>
          )}
        </Box>
      </Stack>
      <Stack>
        <Box component="div" className="modal-btn-grp confirm-poup-grp">
          <Button
            ref={buttonRef1}
            id={'yes-button-id'}
            style={{
              background: 'rgb(255, 0, 0)',
              color: 'white',
              padding: '7px 20px',
              fontSize: '12px',
            }}
            onClick={() => yesAction()}
            onKeyDown={(e) => successPopUpKeyDown(e, buttonRef2)}
          >
            {cs.yes}
          </Button>
          <Button
            ref={buttonRef2}
            id={'no-button-id'}
            style={{ fontSize: '12px' }}
            className="select-lr-btn"
            variant="outlined"
            color="error"
            onClick={() => noAction()}
            onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}
          >
            {cs.no}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
